'use client';

import { c as _c } from "react/compiler-runtime";
import type { JiraIssue } from '@/lib/jira/types';
import { BaseSearchIssues } from '../../../shared/issue/base-search-issues';
import { useJiraIssueSearch } from '@/data/jira/use-issue-search';
type SearchJiraIssuesProps = {
  onSelectAction: (issue: JiraIssue) => void;
  isOpen: boolean;
  onOpenChangeAction: (open: boolean) => void;
  installationId: number;
};
export function SearchJiraIssues(t0) {
  const $ = _c(10);
  const {
    onSelectAction,
    isOpen,
    onOpenChangeAction,
    installationId
  } = t0;
  const {
    search,
    setSearch,
    debouncedSearch,
    searchResults,
    isLoading,
    error
  } = useJiraIssueSearch(installationId);
  let t1;
  if ($[0] !== debouncedSearch || $[1] !== error || $[2] !== isLoading || $[3] !== isOpen || $[4] !== onOpenChangeAction || $[5] !== onSelectAction || $[6] !== search || $[7] !== searchResults || $[8] !== setSearch) {
    t1 = <BaseSearchIssues isOpen={isOpen} onOpenChangeAction={onOpenChangeAction} search={search} setSearch={setSearch} debouncedSearch={debouncedSearch} searchResults={searchResults} isLoading={isLoading} error={error} onSelectAction={onSelectAction} getIssueKey={_temp} getIssueSummary={_temp2} tooltipContent={_temp3} popoverWidthClass="w-80" />;
    $[0] = debouncedSearch;
    $[1] = error;
    $[2] = isLoading;
    $[3] = isOpen;
    $[4] = onOpenChangeAction;
    $[5] = onSelectAction;
    $[6] = search;
    $[7] = searchResults;
    $[8] = setSearch;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}
function _temp3(issue_1) {
  return issue_1.summary;
}
function _temp2(issue_0) {
  return issue_0.summary;
}
function _temp(issue) {
  return issue.key;
}